import React, {PropTypes} from 'react';
import Table, {Column} from '../components/container/Table';
import OutputValue from '../components/output/OutputValue';
import Iterate from '../components/container/Iterate';
import {Vertical} from '../components/container/LayoutRow';
import {OutputAttachmentRowNoName} from '../components/output/OutputAttachments';
import MainContainer from '../components/MainContainer';
import {Route, Switch} from 'react-router-dom';
import SearchPanelSDS from './SearchPanelSDS';
import WithRole from '../components/container/WithRole';
import List from "../cruds/List";
import {MACHINERY_CRUD_ENABLED} from "../components/container/ShowBasedOnConfig";

const ENTITY_NAME = 'substances';
const TITLE = 'substances.title';

const CrudList = (props, context) => {
    const table = <Table>
        <Column label="agents.casRn">
            <OutputValue name="agentCasRn"/>
        </Column>
        <Column label="substances.idCode">
            <OutputValue name="code"/>
        </Column>
        <Column label="substances.sds">
            <WithRole roles={['F']}>
                <Vertical rendered="lastApprovedSafetyDataSheet">
                    <Iterate on="lastApprovedSafetyDataSheet.attachments">
                        <OutputAttachmentRowNoName/>
                    </Iterate>
                </Vertical>
            </WithRole>
        </Column>
    </Table>;

    const user = JSON.parse(localStorage.loggedUser);
    var filters;
    console.log(context);
    if(context.config[MACHINERY_CRUD_ENABLED]) {
        filters = [
            {
                name: 'machineries',
                from: '/machineries',
                placeholder: 'searchSDS.machineries',
                type: 'remote',
                defaultValue: user.machineryIds,
                optionLabelName: "name",
                optionValueName: "id"
            },
            {name: 'fullSearch', placeholder: 'searchSDS.searchField'},
        ];
    }else{
        filters = [
            {name: 'fullSearch', placeholder: 'searchSDS.searchField'},
        ]
    }


    return <List title={TITLE}
                 entityName={ENTITY_NAME}
                 entityRoute={ENTITY_NAME}
                 component={table}
                 filters={filters}
                 hideAddButton={true}
                 panic={true}
    />;

};

CrudList.contextTypes = {
    config: PropTypes.object,
};

const SearchResultPanelSDS = props => {
    const basePath = props.match.url;
    return (
        <MainContainer>
            <Switch>
                <Route exact path={basePath} component={CrudList}/>
                <Route exact path={basePath + '/search'} render={ props => <SearchPanelSDS {...props}/>}/>
            </Switch>
        </MainContainer>
    );
};

export default SearchResultPanelSDS;



// WEBPACK FOOTER //
// ./src/main/pages/SearchResultPanelSDS.js